// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Owl Carousel v2.3.4
 * Copyright 2013-2018 David Deutsch
 * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE
 */
/*
 *  Owl Carousel - Core
 */
 .owl-carousel {
    display: none;
    width: 100%;
    -webkit-tap-highlight-color: transparent;
    /* position relative and z-index fix webkit rendering fonts issue */
    position: relative;
    z-index: 1; }
    .owl-carousel .owl-stage {
      position: relative;
      touch-action: manipulation;
      -moz-backface-visibility: hidden;
      /* fix firefox animation glitch */ }
    .owl-carousel .owl-stage:after {
      content: ".";
      display: block;
      clear: both;
      visibility: hidden;
      line-height: 0;
      height: 0; }
    .owl-carousel .owl-stage-outer {
      position: relative;
      overflow: hidden;
      /* fix for flashing background */
      -webkit-transform: translate3d(0px, 0px, 0px); }
    .owl-carousel .owl-wrapper,
    .owl-carousel .owl-item {
      -webkit-backface-visibility: hidden;
      -moz-backface-visibility: hidden;
      -ms-backface-visibility: hidden;
      -webkit-transform: translate3d(0, 0, 0);
      -moz-transform: translate3d(0, 0, 0);
      -ms-transform: translate3d(0, 0, 0); }
    .owl-carousel .owl-item {
      position: relative;
      min-height: 1px;
      float: left;
      -webkit-backface-visibility: hidden;
      -webkit-tap-highlight-color: transparent;
      -webkit-touch-callout: none; }
    .owl-carousel .owl-item img {
      display: block;
      width: 100%; }
    .owl-carousel .owl-nav.disabled,
    .owl-carousel .owl-dots.disabled {
      display: none; }
    .owl-carousel .owl-nav .owl-prev,
    .owl-carousel .owl-nav .owl-next,
    .owl-carousel .owl-dot {
      cursor: pointer;
      -webkit-user-select: none;
      user-select: none; }
    .owl-carousel .owl-nav button.owl-prev,
    .owl-carousel .owl-nav button.owl-next,
    .owl-carousel button.owl-dot {
      background: none;
      color: inherit;
      border: none;
      padding: 0 !important;
      font: inherit; }
    .owl-carousel.owl-loaded {
      display: block; }
    .owl-carousel.owl-loading {
      opacity: 0;
      display: block; }
    .owl-carousel.owl-hidden {
      opacity: 0; }
    .owl-carousel.owl-refresh .owl-item {
      visibility: hidden; }
    .owl-carousel.owl-drag .owl-item {
      touch-action: pan-y;
      -webkit-user-select: none;
      user-select: none; }
    .owl-carousel.owl-grab {
      cursor: move;
      cursor: grab; }
    .owl-carousel.owl-rtl {
      direction: rtl; }
    .owl-carousel.owl-rtl .owl-item {
      float: right; }
  
  /* No Js */
  .no-js .owl-carousel {
    display: block; }
  
  /*
   *  Owl Carousel - Animate Plugin
   */
  .owl-carousel .animated {
    animation-duration: 1000ms;
    animation-fill-mode: both; }
  
  .owl-carousel .owl-animated-in {
    z-index: 0; }
  
  .owl-carousel .owl-animated-out {
    z-index: 1; }
  
  .owl-carousel .fadeOut {
    animation-name: fadeOut; }
  
  @keyframes fadeOut {
    0% {
      opacity: 1; }
    100% {
      opacity: 0; } }
  
  /*
   * 	Owl Carousel - Auto Height Plugin
   */
  .owl-height {
    transition: height 500ms ease-in-out; }
  
  /*
   * 	Owl Carousel - Lazy Load Plugin
   */
  .owl-carousel .owl-item {
    /**
              This is introduced due to a bug in IE11 where lazy loading combined with autoheight plugin causes a wrong
              calculation of the height of the owl-item that breaks page layouts
           */ }
    .owl-carousel .owl-item .owl-lazy {
      opacity: 0;
      transition: opacity 400ms ease; }
    .owl-carousel .owl-item .owl-lazy[src^=""], .owl-carousel .owl-item .owl-lazy:not([src]) {
      max-height: 0; }
    .owl-carousel .owl-item img.owl-lazy {
      transform-style: preserve-3d; }
  
  /*
   * 	Owl Carousel - Video Plugin
   */
  .owl-carousel .owl-video-wrapper {
    position: relative;
    height: 100%;
    background: #000; }
  
  .owl-carousel .owl-video-play-icon {
    position: absolute;
    height: 80px;
    width: 80px;
    left: 50%;
    top: 50%;
    margin-left: -40px;
    margin-top: -40px;
    /* background: url("../public/assets/images/owl.video.play.png") no-repeat; */
    cursor: pointer;
    z-index: 1;
    -webkit-backface-visibility: hidden;
    transition: transform 100ms ease; }
  
  .owl-carousel .owl-video-play-icon:hover {
    transform: scale(1.3, 1.3); }
  
  .owl-carousel .owl-video-playing .owl-video-tn,
  .owl-carousel .owl-video-playing .owl-video-play-icon {
    display: none; }
  
  .owl-carousel .owl-video-tn {
    opacity: 0;
    height: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    transition: opacity 400ms ease; }
  
  .owl-carousel .owl-video-frame {
    position: relative;
    z-index: 1;
    height: 100%;
    width: 100%; }`, "",{"version":3,"sources":["webpack://./src/Owl.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;;EAEE;CACD;IACG,aAAa;IACb,WAAW;IACX,wCAAwC;IACxC,mEAAmE;IACnE,kBAAkB;IAClB,UAAU,EAAE;IACZ;MACE,kBAAkB;MAElB,0BAA0B;MAC1B,gCAAgC;MAChC,iCAAiC,EAAE;IACrC;MACE,YAAY;MACZ,cAAc;MACd,WAAW;MACX,kBAAkB;MAClB,cAAc;MACd,SAAS,EAAE;IACb;MACE,kBAAkB;MAClB,gBAAgB;MAChB,gCAAgC;MAChC,6CAA6C,EAAE;IACjD;;MAEE,mCAAmC;MACnC,gCAAgC;MAChC,+BAA+B;MAC/B,uCAAuC;MACvC,oCAAoC;MACpC,mCAAmC,EAAE;IACvC;MACE,kBAAkB;MAClB,eAAe;MACf,WAAW;MACX,mCAAmC;MACnC,wCAAwC;MACxC,2BAA2B,EAAE;IAC/B;MACE,cAAc;MACd,WAAW,EAAE;IACf;;MAEE,aAAa,EAAE;IACjB;;;MAGE,eAAe;MACf,yBAAyB;MAIzB,iBAAiB,EAAE;IACrB;;;MAGE,gBAAgB;MAChB,cAAc;MACd,YAAY;MACZ,qBAAqB;MACrB,aAAa,EAAE;IACjB;MACE,cAAc,EAAE;IAClB;MACE,UAAU;MACV,cAAc,EAAE;IAClB;MACE,UAAU,EAAE;IACd;MACE,kBAAkB,EAAE;IACtB;MAEM,mBAAmB;MACvB,yBAAyB;MAGzB,iBAAiB,EAAE;IACrB;MACE,YAAY;MACZ,YAAY,EAAE;IAChB;MACE,cAAc,EAAE;IAClB;MACE,YAAY,EAAE;;EAElB,UAAU;EACV;IACE,cAAc,EAAE;;EAElB;;IAEE;EACF;IACE,0BAA0B;IAC1B,yBAAyB,EAAE;;EAE7B;IACE,UAAU,EAAE;;EAEd;IACE,UAAU,EAAE;;EAEd;IACE,uBAAuB,EAAE;;EAE3B;IACE;MACE,UAAU,EAAE;IACd;MACE,UAAU,EAAE,EAAE;;EAElB;;IAEE;EACF;IACE,oCAAoC,EAAE;;EAExC;;IAEE;EACF;IACE;;;YAGQ,EAAE;IACV;MACE,UAAU;MACV,8BAA8B,EAAE;IAClC;MACE,aAAa,EAAE;IACjB;MACE,4BAA4B,EAAE;;EAElC;;IAEE;EACF;IACE,kBAAkB;IAClB,YAAY;IACZ,gBAAgB,EAAE;;EAEpB;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,SAAS;IACT,QAAQ;IACR,kBAAkB;IAClB,iBAAiB;IACjB,6EAA6E;IAC7E,eAAe;IACf,UAAU;IACV,mCAAmC;IACnC,gCAAgC,EAAE;;EAEpC;IAEM,0BAA0B,EAAE;;EAElC;;IAEE,aAAa,EAAE;;EAEjB;IACE,UAAU;IACV,YAAY;IACZ,kCAAkC;IAClC,4BAA4B;IAC5B,wBAAwB;IACxB,8BAA8B,EAAE;;EAElC;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,WAAW,EAAE","sourcesContent":["/**\n * Owl Carousel v2.3.4\n * Copyright 2013-2018 David Deutsch\n * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE\n */\n/*\n *  Owl Carousel - Core\n */\n .owl-carousel {\n    display: none;\n    width: 100%;\n    -webkit-tap-highlight-color: transparent;\n    /* position relative and z-index fix webkit rendering fonts issue */\n    position: relative;\n    z-index: 1; }\n    .owl-carousel .owl-stage {\n      position: relative;\n      -ms-touch-action: pan-Y;\n      touch-action: manipulation;\n      -moz-backface-visibility: hidden;\n      /* fix firefox animation glitch */ }\n    .owl-carousel .owl-stage:after {\n      content: \".\";\n      display: block;\n      clear: both;\n      visibility: hidden;\n      line-height: 0;\n      height: 0; }\n    .owl-carousel .owl-stage-outer {\n      position: relative;\n      overflow: hidden;\n      /* fix for flashing background */\n      -webkit-transform: translate3d(0px, 0px, 0px); }\n    .owl-carousel .owl-wrapper,\n    .owl-carousel .owl-item {\n      -webkit-backface-visibility: hidden;\n      -moz-backface-visibility: hidden;\n      -ms-backface-visibility: hidden;\n      -webkit-transform: translate3d(0, 0, 0);\n      -moz-transform: translate3d(0, 0, 0);\n      -ms-transform: translate3d(0, 0, 0); }\n    .owl-carousel .owl-item {\n      position: relative;\n      min-height: 1px;\n      float: left;\n      -webkit-backface-visibility: hidden;\n      -webkit-tap-highlight-color: transparent;\n      -webkit-touch-callout: none; }\n    .owl-carousel .owl-item img {\n      display: block;\n      width: 100%; }\n    .owl-carousel .owl-nav.disabled,\n    .owl-carousel .owl-dots.disabled {\n      display: none; }\n    .owl-carousel .owl-nav .owl-prev,\n    .owl-carousel .owl-nav .owl-next,\n    .owl-carousel .owl-dot {\n      cursor: pointer;\n      -webkit-user-select: none;\n      -khtml-user-select: none;\n      -moz-user-select: none;\n      -ms-user-select: none;\n      user-select: none; }\n    .owl-carousel .owl-nav button.owl-prev,\n    .owl-carousel .owl-nav button.owl-next,\n    .owl-carousel button.owl-dot {\n      background: none;\n      color: inherit;\n      border: none;\n      padding: 0 !important;\n      font: inherit; }\n    .owl-carousel.owl-loaded {\n      display: block; }\n    .owl-carousel.owl-loading {\n      opacity: 0;\n      display: block; }\n    .owl-carousel.owl-hidden {\n      opacity: 0; }\n    .owl-carousel.owl-refresh .owl-item {\n      visibility: hidden; }\n    .owl-carousel.owl-drag .owl-item {\n      -ms-touch-action: pan-y;\n          touch-action: pan-y;\n      -webkit-user-select: none;\n      -moz-user-select: none;\n      -ms-user-select: none;\n      user-select: none; }\n    .owl-carousel.owl-grab {\n      cursor: move;\n      cursor: grab; }\n    .owl-carousel.owl-rtl {\n      direction: rtl; }\n    .owl-carousel.owl-rtl .owl-item {\n      float: right; }\n  \n  /* No Js */\n  .no-js .owl-carousel {\n    display: block; }\n  \n  /*\n   *  Owl Carousel - Animate Plugin\n   */\n  .owl-carousel .animated {\n    animation-duration: 1000ms;\n    animation-fill-mode: both; }\n  \n  .owl-carousel .owl-animated-in {\n    z-index: 0; }\n  \n  .owl-carousel .owl-animated-out {\n    z-index: 1; }\n  \n  .owl-carousel .fadeOut {\n    animation-name: fadeOut; }\n  \n  @keyframes fadeOut {\n    0% {\n      opacity: 1; }\n    100% {\n      opacity: 0; } }\n  \n  /*\n   * \tOwl Carousel - Auto Height Plugin\n   */\n  .owl-height {\n    transition: height 500ms ease-in-out; }\n  \n  /*\n   * \tOwl Carousel - Lazy Load Plugin\n   */\n  .owl-carousel .owl-item {\n    /**\n              This is introduced due to a bug in IE11 where lazy loading combined with autoheight plugin causes a wrong\n              calculation of the height of the owl-item that breaks page layouts\n           */ }\n    .owl-carousel .owl-item .owl-lazy {\n      opacity: 0;\n      transition: opacity 400ms ease; }\n    .owl-carousel .owl-item .owl-lazy[src^=\"\"], .owl-carousel .owl-item .owl-lazy:not([src]) {\n      max-height: 0; }\n    .owl-carousel .owl-item img.owl-lazy {\n      transform-style: preserve-3d; }\n  \n  /*\n   * \tOwl Carousel - Video Plugin\n   */\n  .owl-carousel .owl-video-wrapper {\n    position: relative;\n    height: 100%;\n    background: #000; }\n  \n  .owl-carousel .owl-video-play-icon {\n    position: absolute;\n    height: 80px;\n    width: 80px;\n    left: 50%;\n    top: 50%;\n    margin-left: -40px;\n    margin-top: -40px;\n    /* background: url(\"../public/assets/images/owl.video.play.png\") no-repeat; */\n    cursor: pointer;\n    z-index: 1;\n    -webkit-backface-visibility: hidden;\n    transition: transform 100ms ease; }\n  \n  .owl-carousel .owl-video-play-icon:hover {\n    -ms-transform: scale(1.3, 1.3);\n        transform: scale(1.3, 1.3); }\n  \n  .owl-carousel .owl-video-playing .owl-video-tn,\n  .owl-carousel .owl-video-playing .owl-video-play-icon {\n    display: none; }\n  \n  .owl-carousel .owl-video-tn {\n    opacity: 0;\n    height: 100%;\n    background-position: center center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    transition: opacity 400ms ease; }\n  \n  .owl-carousel .owl-video-frame {\n    position: relative;\n    z-index: 1;\n    height: 100%;\n    width: 100%; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
